module.exports = __webpack_public_path__ + "static/media/sitting_two_hands_seperated.fb9dcd5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/assets/quick-play-icons/sitting_two_hands_seperated.png
// module id = 728
// module chunks = 0